<div class="card card-box mb-5 p-5">
    <div class="row mb-5">
        <div class="col-xl-4">
            <a [routerLink]="" class="card-img-wrapper rounded">
                <div class="img-wrapper-overlay">
                    <div class="overlay-btn-wrapper">
                        <button class="btn btn-first p-0 d-50 rounded-circle" type="button">
                            <span class="btn-wrapper--icon">
                                <fa-icon [icon]="['fas', 'play-circle']"></fa-icon>
                            </span>
                        </button>
                    </div>
                </div>
                <div class="card-badges card-badges-bottom">
                    <span class="badge badge-pill badge-warning">Warning</span>
                </div>
                <img alt="..." class="card-img-top rounded" src="assets/images/stock-photos/people-1.jpg"/>
            </a>
        </div>
        <div class="col-xl-8">
            <a [routerLink]="" class="font-size-xxl d-block my-4">
                New order has been received
            </a>
            <p class="text-black-50 font-size-lg">
                Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for
                previewing layouts and visual mockups.
            </p>
            <p class="text-black-50 font-size-lg mb-0">
                Lorem ipsum dolor sit amet,consectetuer edipiscing elit,sed diam nonummy nibh euismod tinciduntut
                laoreet doloremagna aliquam erat volutpat.
            </p>

            <div class="d-flex align-items-center mt-4">
                <div class="avatar-icon-wrapper avatar-icon-lg  mr-2">
                    <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar2.jpg"/></div>
                </div>
                <div>
                    <a [routerLink]="" class="font-weight-bold text-black" title="...">Shanelle Wynn</a>
                    <span class="text-black-50 d-block">Web Developer, Apple Inc.</span>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-xl-4">
            <a [routerLink]="" class="card-img-wrapper rounded">
                <div class="img-wrapper-overlay">
                    <div class="overlay-btn-wrapper">
                        <button class="btn btn-first p-0 d-50 rounded-circle" type="button">
                            <span class="btn-wrapper--icon">
                                <fa-icon [icon]="['fas', 'play-circle']"></fa-icon>
                            </span>
                        </button>
                    </div>
                </div>
                <div class="card-badges card-badgestop">
                    <span class="badge badge-pill badge-success">New</span>
                </div>
                <img alt="..." class="card-img-top rounded" src="assets/images/stock-photos/people-2.jpg"/>
            </a>
        </div>
        <div class="col-xl-8">
            <a [routerLink]="" class="font-size-xxl d-block my-4">
                New report file has been uploaded
            </a>
            <p class="text-black-50 font-size-lg mb-0">
                Lorem ipsum dolor sit amet,consectetuer edipiscing elit,sed diam nonummy nibh euismod tinciduntut
                laoreet doloremagna aliquam erat volutpat.
            </p>

            <div class="d-flex align-items-center mt-4">
                <div class="avatar-icon-wrapper avatar-icon-lg  mr-2">
                    <div class="avatar-icon"><img alt="..." src="assets/images/avatars/avatar3.jpg"/></div>
                </div>
                <div>
                    <a [routerLink]="" class="font-weight-bold text-black" title="...">Aaran Mitchell</a>
                    <span class="text-black-50 d-block">UI Engineer, Google</span>
                </div>
            </div>
        </div>
    </div>
</div>
